import { useQuery } from '@tanstack/react-query';
import { request } from '../api/client';
import { useAuthStore } from '../store/auth';

/** Navbar "active work" counts. Keys are present only for permissions the user holds. */
export interface BadgeCounts {
  ordersActive?: number;
  ordersPendingApproval?: number;
  ordersAwaitingTransfer?: number;
  adjustmentsPendingApproval?: number;
  transfersAwaitingReceipt?: number;
  transfersAwaitingDispatch?: number;
  paymentsPending?: number;
  expenseAwaitingMe?: number;
  advanceRequestsAwaitingMe?: number;
  myAdvanceRequestsPending?: number;
  openInvoices?: number;
  openComplaints?: number;
  attendanceAnomalies?: number;
  attendanceIncomplete?: number;
  regularizationsPending?: number;
  territoriesUnassigned?: number;
  coverageNeeded?: number;
  upcomingEvents?: number;
  openInquiries?: number;
  shortfallsOpen?: number;
  returnsActionable?: number;
}

/**
 * Live badge counts for the navbar. Polls every 60s and refetches on tab focus,
 * so pending-work indicators stay current without a reload. Backend computes them
 * permission-gated + self-scoped; the UI only renders.
 */
export function useBadges(): BadgeCounts {
  const token = useAuthStore((s) => s.accessToken);
  const { data } = useQuery({
    queryKey: ['badges'],
    queryFn: () => request<BadgeCounts>({ url: '/badges' }),
    enabled: !!token,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
  return data ?? {};
}
